import { useRestart } from '@hooks/utils/useRestart';
import { isDeviceError } from '@stores/atoms/device';
import { useResetAtom } from 'jotai/utils';
import type { FC, MouseEventHandler } from 'react';
import Modal from '../Interview';

const DeviceErrorModal: FC = () => {
  const { executeRestart } = useRestart();
  const resetDeviceError = useResetAtom(isDeviceError);

  const onClickConfirm: MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.stopPropagation();
    resetDeviceError();
    await executeRestart();
  };

  return (
    <Modal onClickConfirm={onClickConfirm} isUnrejectable={true}>
      사용자 디바이스 연결에 문제가 있습니다.
      <br />
      서비스 이용 중 동일한 현상이 반복될 경우, 관리자 또는 고객센터에 문의해
      주시기 바랍니다.
    </Modal>
  );
};

export default DeviceErrorModal;
